<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xxiv"></a><a id="page_1"></a>Faces <em>of the</em> Confederacy</p>
<h2 class="h2" id="car">CARTES DE VISITE</h2>
<div class="pagebreak">
<p class="noindent"> </p>
</div>
<p class="image1"><a id="page_2"></a><img alt="image" src="images/f0002-01.jpg"/></p>
<p class="caption">Capt. Richard Curzon Hoffman, Company E, Thirtieth Battalion Virginia Sharpshooters</p>
<p class="noindent"><em>Carte de visite</em> published by Selby &amp; McCauley of Baltimore, Maryland, from a negative by Stephen Israel (life dates unknown) &amp; Co. of Baltimore, about 1865. Collection of The Museum of the Confederacy, Richmond, Virginia.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cartesdevisite.vue?54e25e44